


export type SalesOrderStateFlags = 'ForwardStatusFromDigizeitNeeded' | 'ForwardedStatus';

export const SalesOrderStateFlags = {
    ForwardStatusFromDigizeitNeeded: 'ForwardStatusFromDigizeitNeeded' as SalesOrderStateFlags,
    ForwardedStatus: 'ForwardedStatus' as SalesOrderStateFlags
};

